import { render, staticRenderFns } from "./UiContainer.vue?vue&type=template&id=5794740f&"
import script from "./UiContainer.vue?vue&type=script&lang=js&"
export * from "./UiContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports